// Common strings shared across every GetPaid feature: app name/tagline, the
// primary nav labels, and generic actions reused by more than one screen.
// Per-feature modules (auth, shell, onboarding, invoices, affiliate) get
// their own file — see src/i18n/index.ts for how they're merged in.
const common: Record<string, string> = {
  'app.name': 'GetPaid',
  'app.tagline': 'Get paid from abroad, straight into your Pix.',

  'common.nav.onboarding': 'Onboarding',
  'common.nav.invoices': 'Invoices',
  'common.nav.affiliate': 'Affiliate',

  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.signOut': 'Sign out',
  'common.loading': 'Loading...',
  'common.error.generic': 'Something went wrong. Please try again.',
};

export default common;
